import React from 'react';
import {mapRefDataCode} from 'common/utils';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Form} from 'semantic-ui-react';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import {connectWithCore} from 'framework/hocs';
import _ from 'lodash';
import REST from 'go/requests/rest';

export const phoneNumberOptions = [
  {key: 0, value: '', text: ''},
  {key: 1, value: 'home', text: 'Home'},
  {key: 2, value: 'work', text: 'Work'},
  {key: 3, value: 'mobile', text: 'Mobile'},
];

export const WORK = 10;
export const MOBILE = 6;
export const HOME = 4;
export const OTHER = 7;
export const WORK_FAX = 3;

class AorContactInfoModal extends React.Component {
  state = {
    retrievedOrgMembers: false,
    orgAors: [],
    refData: {
      salutationType: [],
    },
  };

  handleChange = (name, value) => {
    this.props.handleChange(name, value);
  };

  componentDidMount() {
    REST.ref
      .getPrefixes()
      .then((res) => res.json())
      .then((resJson) => {
        let refData = {
          salutationType: mapRefDataCode(resJson.PREFIX),
        };
        this.setState({refData: refData});
      })
      .catch((error) => {
        console.error('error');
      });

    this.retrieveOrgMembers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.organizationId !== prevProps.organizationId) {
      this.retrieveOrgMembers();
    }
  }

  retrieveOrgMembers() {
    if (!this.state.retrievedOrgMembers && this.props.organizationId) {
      REST.user
        .getAorList(this.props.token, this.props.organizationId, this.props.programId)
        .then(REST.handler.handleResponse)
        .then((result) => {
          this.setState({
            retrievedOrgMembers: true,
            orgAors: result,
          });
        })
        .catch((err) => {
          console.log('err');
        });
    }
  }

  sortPhoneNumbers = (phoneNumbers) => {
    const order = [WORK, MOBILE, HOME, OTHER, WORK_FAX];
    const phonesNotInListByType = _.filter(
      phoneNumbers,
      (p) => !order.includes(p.phoneType)
    );
    const phonesInListByType = _.filter(phoneNumbers, (p) => order.includes(p.phoneType));

    const phoneNumbersInOrderByType = _.sortBy(phonesInListByType, (p) =>
      order.indexOf(p.phoneType)
    );
    const phoneNumbersInOrder = phoneNumbersInOrderByType.concat(phonesNotInListByType);

    return phoneNumbersInOrder;
  };

  handleChoosingUser = (index) => {
    const {orgAors} = this.state;
    const userToPrepopFrom = _.get(orgAors, index, {});
    const phoneNumbers = _.get(userToPrepopFrom, 'phoneNumbers', []);

    const sortedPhoneNumbers = this.sortPhoneNumbers(phoneNumbers);

    if (_.isEmpty(sortedPhoneNumbers)) {
      const emptyPhoneNumber = {
        phoneNumber: 'N/A',
      };
      sortedPhoneNumbers.push(emptyPhoneNumber);
    }

    const userToSave = {
      firstName: _.get(userToPrepopFrom, 'firstName', ''),
      lastName: _.get(userToPrepopFrom, 'lastName', ''),
      userId: _.get(userToPrepopFrom, 'userId', ''),
      phoneNumbers: sortedPhoneNumbers,
      emailAdr: _.get(userToPrepopFrom, 'emailAdr', ''),
      enteredBy: _.get(userToPrepopFrom, 'enteredBy', ''),
      entryDate: _.get(userToPrepopFrom, 'entryDate', ''),
      modifiedBy: _.get(userToPrepopFrom, 'modifiedBy', ''),
      modifyDate: _.get(userToPrepopFrom, 'modifyDate', ''),
      activatedInd: _.get(userToPrepopFrom, 'activatedInd', ''),
    };

    this.props.handleChoose(userToSave);
    this.setState({
      selectedContact: index,
    });
  };

  render() {
    const {open, type, config, handleClose, handleDelete, contact} = this.props;
    const {orgAors, selectedContact = -1} = this.state;

    const userAORorSAR = false;

    const isAors = userAORorSAR ? type === 'sars' : type === 'aor';

    //can just be orgAors
    const dpOptions = orgAors;

    let headerOptions = [
      {
        key: -2,
        value: -2,
        text: 'Select',
      },
    ];
    if (isAors) _.remove(headerOptions, (item) => item.key === -1);
    let prepopOptions = _.concat(
      headerOptions,
      _.map(dpOptions, (member, index) => {
        return {
          key: index,
          value: index,
          text: `${member.firstName} ${member.lastName} (${member.emailAdr})`,
        };
      })
    );

    const defaultDpLabel = 'Select the user being added as an AOR';

    const dpLabel = _.get(config, 'modal.dpLabel')
      ? _.get(config, 'modal.dpLabel')
      : defaultDpLabel;

    const defaultModalHeading = 'Add AOR';

    const modalEditHeading = _.get(config, 'modal.heading.edit')
      ? _.get(config, 'modal.heading.edit')
      : defaultModalHeading;

    const modalAddHeading = _.get(config, 'modal.heading.add')
      ? _.get(config, 'modal.heading.add')
      : defaultModalHeading;

    const modalHeading = contact && contact.email ? modalEditHeading : modalAddHeading;

    const defaultDpInstructions = '';

    const dpInstructions = _.get(config, 'modal.dpInstructions')
      ? _.get(config, 'modal.dpInstructions')
      : defaultDpInstructions;

    return (
      open && (
        <FemaGoModal
          title={modalHeading}
          open={open}
          type={type}
          confirmButton={isAors ? true : 'hidden'}
          buttonText={'Add this AOR'}
          confirmAction={() => {
            if (selectedContact === -1) {
              handleDelete();
            } else {
              handleClose();
            }
            // this resets selectedContact after confirming
            this.setState({
              selectedContact: -1,
            });
          }}
          cancelAction={isAors ? handleDelete : handleClose}
          cancelButtonText={isAors ? 'Cancel' : 'Close'}
          size="large"
        >
          <p>{dpInstructions}</p>
          <Form>
            <br />
            <InlineSelect
              placeholder="-select-"
              id="participants"
              search
              selection
              label={dpLabel}
              name="participants"
              ariaLabelledBy="addUserContent"
              // value={-2}
              options={prepopOptions}
              handleChange={(event) => {
                this.handleChoosingUser(_.toNumber(event.target.value));
              }}
            />
            <React.Fragment>
              <input
                type="hidden"
                name="firstName"
                value={_.get(contact, 'firstName', '')}
              />
              <input
                type="hidden"
                name="lastName"
                value={_.get(contact, 'lastName', '')}
              />
              <input type="hidden" name="userId" value={_.get(contact, 'userId', '')} />
              {contact && contact.userId && (
                <Alert
                  id="addUserContent"
                  size="medium"
                  header=""
                  htmlContent={`Is this the person you want to add as an AOR?<p>${contact.firstName} ${contact.lastName} (${contact.emailAdr})</p>`}
                  type="info"
                  dismissable={false}
                />
              )}
            </React.Fragment>
          </Form>
        </FemaGoModal>
      )
    );
  }
}

export default connectWithCore(AorContactInfoModal);
